export const extractUsername = (input: string) => {
  const urlRegex =
    /(?:https?:\/\/)?(?:www\.)?(instagram\.com|tiktok\.com|onlyfans\.com)\/(?:@)?([^/?]+)/
  const match = input.match(urlRegex)

  if (match) {
    return match[2]
  }

  if (input.startsWith('@')) {
    return input.slice(1)
  }

  return input
}
